export default class MailService {
	/**
	 * Sends a mail from the contact form to myself
	 * @param {} formData 
	 */
	sendContactMail(formData) {
		return new Promise((resolve, reject) => {
			fetch('admin/sendmail.php', {
				method: 'POST',
				body: JSON.stringify(formData),
				headers: {
					"Content-Type": "application/json"
				}
			}).then(response => {
				if (response.status < 200 || response.status > 300) {
					reject(false);
				} else {
					resolve(true);
				}
			}).catch(() => {
				reject(false);
			});
		});
	}

	/**
	 * Send an email from the purchased form
	 * @param {*} formData 
	 */
	sendPurchaseEmail(formData) {
		return new Promise((resolve, reject) => {
			fetch('admin/sendpurchasemail.php', {
				method: 'POST',
				body: JSON.stringify(formData),
				headers: {
					"Content-Type": "application/json"
				}
			}).then(response => {
				if (response.status < 200 || response.status > 300) {
					reject(false);
				} else {
					resolve(true);
				}
			}).catch(() => {
				reject(false);
			});
		});
	}

	/**
	 * Direct share an url via email
	 * @param {*} url 
	 */
	shareUrlViaEmail(url, email) {
		return new Promise((resolve, reject) => {

			fetch('admin/shareurl.php', {
				method: 'POST',
				body: JSON.stringify({
					url: url,
					email: email
				}),
				headers: {
					"Content-Type": "application/json"
				}
			}).then(response => {
				if (response.status < 200 || response.status > 300) {
					reject(false);
				} else {
					resolve(true);
				}
			}).catch(() => {
				reject(false);
			});
		});
	}

	/**
	 * Check if given email string is in correct format
	 * @param {*} email 
	 */
	isEmailFormatCorrect(email) {
		// eslint-disable-next-line
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
}